import rangeSlider from 'rangeslider.js';
import $ from 'jquery';
class Calculator {
    constructor() {
        this.form = $('#calculator-form');
        this.rangeslider = $('.js-amount-range');
        this.resultWrapper = $('.js-result-wrapper');
        this.quantityNav = $('.quantity');
        this.postCode = $('#calculator-post-code');
        this.loader = $('#calculator-form .loader-container');
        this.vendorsInput = this.form.find('.js-vendors-wrap input');
        this.modelsInput = this.form.find('.js-models-wrap input');
        this.events();
        this.initRangeSlider();
    }
    events() {
        this.postCode.on('keyup', (e) => this.postCodeFormat(e));
        this.quantityNav.each((i, element) => this.quantityChange($(element)));
        this.form.on('submit', (e) => this.submitForm(e));
        this.initAutomplete(this.vendorsInput, 'vendors');
        this.initAutomplete(this.modelsInput, 'models');
    }

    initAutomplete(input, type) {
        input.on('input', e => this.fetchAutomplete(e, type));
        input.on('click', e => this.fetchAutomplete(e, type));
        this.useSuggestion(input);
    }

    fetchAutomplete(e, type) {
        const value = e.target.value;
        const input = e.target;
        if (value.length < 2) {
            return;
        }

        const url = `${compensa_general.link}/wp-json/cmp_services/${type}?search=${value}`;
        $.ajax({
            url,
            type: 'get',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: (response) => {
                this.showSuggestions(response, input);
            }
        });
    }
    showSuggestions(results, input) {
        const suggestionsList = $(input).parent().find('.js-calculator-suggestions ul');
        $(input).addClass('no-border');
        suggestionsList.html('');
        if (results.length > 0) {
            for (let i = 0; i < results.length; i++) {
                let item = results[i];
                suggestionsList.append(`<li>${item}</li>`);
            }
            suggestionsList.addClass('has-suggestions');
        } else {
            results = [];
            suggestionsList.html('');
            suggestionsList.removeClass('has-suggestions');
            $(input).removeClass('no-border');
        }
    }
    useSuggestion(input) {
        const suggestionsList = $(input).parent().find('.js-calculator-suggestions ul');
        $(suggestionsList).on('click', (e) => {
            input[0].value = $(e.target).text();
            input.focus();
            suggestionsList.html('');
            suggestionsList.removeClass('has-suggestions');
            $(input).removeClass('no-border');
        });
        $(document).click(function (event) {
            var $target = $(event.target);
            if (!$target.closest(suggestionsList).length &&
                $(suggestionsList).is(":visible")) {
                suggestionsList.html();
                suggestionsList.removeClass('has-suggestions');
                $(input).removeClass('no-border');
            }
        });
    }

    initRangeSlider() {
        this.rangeslider
            .rangeslider({
                polyfill: false
            })
            .on('input', function () {
                $(this).parent().find('.js-amount-input')[0].value = this.value;
            });
    }
    quantityChange(spinner) {
        const input = spinner.find('input[type="number"]'),
            btnUp = spinner.find('.quantity-up'),
            btnDown = spinner.find('.quantity-down'),
            min = input.attr('min'),
            max = input.attr('max');
        btnUp.click(function () {
            let oldValue = parseFloat(input.val());
            let newVal = 0;
            if (oldValue >= max) {
                newVal = oldValue;
            } else {
                newVal = oldValue + 1;
            }
            input.val(newVal);
            input.trigger("change");
            spinner.parent().find('.js-amount-range').val(newVal).change();
        });
        btnDown.click(function () {
            let oldValue = parseFloat(input.val());
            let newVal = 0;
            if (oldValue <= min) {
                newVal = oldValue;
            } else {
                newVal = oldValue - 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
            spinner.parent().find('.js-amount-range').val(newVal).change();
        });
        input.on('change', function () {
            spinner.parent().find('.js-amount-range').val($(this).val()).change();
        })
    }
    postCodeFormat(event) {
        const code = this.postCode.val();
        const key = event.keyCode || event.charCode;
        if (this.postCode.val().length == 2) {
            if (key == 8 || key == 46) {} else {
                this.postCode.val(code + '-');
            }
        }
        if (this.postCode.val().indexOf('--') !== -1) {
            this.postCode.val(code.replace('--', '-'));
        }
    }
    formatData($form) {
        const unindexedArr = $form.serializeArray();
        const dataObject = {};
        $.map(unindexedArr, function (n, i) {
            dataObject[n['name']] = n['value'];
        });
        return dataObject;
    }
    submitForm(e) {
        e.preventDefault();
        const data = this.formatData(this.form)
        this.loader.css('display', 'block');
        var url = `${compensa_general.link}/wp-json/cmp_services/oc-calculation`;

        $.ajax({
            url,
            type: 'post',
            data: JSON.stringify(data),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: (response) => {
                this.showResult(response.calculation)
            },
            error: () => {
                this.addError();
            },
            complete: () => {
                this.loader.css('display', 'none');
            }
        });
    }
    showResult(result) {
        $('.calculator-error').remove();
        if (!this.resultWrapper.is(':visible')) {
            this.resultWrapper.css('display', 'block');
        }
        this.resultWrapper.find('.js-calculator-result').text(result);
    }
    addError() {
        if ($('.calculator-error').length === 0) {
            this.resultWrapper.parent().append(`<p class="calculator-error">Sorry, something went wrong. </p>`);
        }
    }
}
export default Calculator;